import { render, staticRenderFns } from "./quoteDetail.vue?vue&type=template&id=0fd6376f&scoped=true"
import script from "./quoteDetail.vue?vue&type=script&lang=js"
export * from "./quoteDetail.vue?vue&type=script&lang=js"
import style0 from "./quoteDetail.vue?vue&type=style&index=0&id=0fd6376f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6376f",
  null
  
)

export default component.exports